import { Component, OnInit, OnDestroy, AfterViewChecked, ChangeDetectorRef } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { HttpClient } from '@angular/common/http';

import { Globals } from './_globals/globals';

import { AuthenticationService } from './_services/Authentication.service';

import { User } from './_models/user';
import { Store, select } from '@ngrx/store';
import { Router } from '@angular/router';
import * as fromUser from './user/state/user.reducer';
import * as fromRoot from './state/app.reducer';
import * as userActions from './user/state/user.actions';
import * as fileActions from './file/state/file.actions';
import * as optiActions from './opti/state/opti.actions';
import * as cuttingTableActions from './maestros/cutting_table/state/cutting_table.actions';
import * as easelActions from './maestros/easel/state/easel.actions';
import * as reasonActions from './maestros/reason/state/reason.actions';
import * as rootActions from './state/app.actions';
import { takeWhile } from 'rxjs/operators';
import { Observable } from 'rxjs';

import { Translation } from './_languages/translations';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent implements OnInit, OnDestroy, AfterViewChecked {

  // Para el control del diccionario de traducción.
  languageOption: string;
  vocabulary$: Observable<{}>;
  tr: {};

  currentUser: User;
  toggleNav: boolean;
  toggleModal: boolean;
  error = '';

  loading: boolean;
  loading1: boolean;
  loading2: boolean;
  loading3: boolean;
  loading4: boolean;
  loading5: boolean;
  loading6: boolean;

  alertModal: boolean;
  alertInfo: string;

  infoModal: boolean;
  infoInfo: string;
  linkInfo: string;
  paramInfo: any;
  skinInfo: string;

  button_color: string;

  componentActive = true;

  setTimeoutConfirmModal: number;
  optimizationVisualProgress: number;
  optimizationVisualIteration: number;
  optimizationVisualAttempts: number;
  optimizationVisualStartTs: number;
  optimizationVisualElapsedText: string;
  optimizationVisualSpeedLabel: string;
  optimizationVisualSheets: number;
  optimizationCancelRequested: boolean;
  optimizationVisualTimer: any;
  optimizationVisualActive: boolean;
  autoExecOverlayVisible: boolean;
  autoExecOverlayCurrentMaterial: string;
  autoExecOverlayCompleted: number;
  autoExecOverlayTotal: number;
  autoExecOverlayPending: number;
  autoExecOverlayPercent: number;
  autoExecOverlayCurrentStep: number;
  autoExecOverlayPulse: number;
  autoExecOverlayElapsedText: string;
  autoExecOverlayHeartbeatText: string;
  autoExecOverlayStalled: boolean;
  autoExecOverlayTimer: any;
  

  constructor(
    private globals: Globals,
    private http: HttpClient,
    private authenticationService: AuthenticationService,
    private store: Store<fromUser.State>,
    private storeRoot: Store<fromRoot.State>,
    private router: Router,
    public trans: Translation,
    // NOTA: variable necesaria para evitar el error de chequeo por los "ngIf" cambiantes.
    private cdRef: ChangeDetectorRef,
    private browserTitle: Title
  ) {
        this.toggleNav = false;
        this.toggleModal = false;
        this.authenticationService.currentUser.subscribe(x => {
          this.currentUser = x;
          this.browserTitle.setTitle(this.applicationName);
          if (this.isManufacturer) {
            setTimeout(() => this.captureManufacturerGeolocation(), 0);
          }
        });

  }

  get isManufacturer(): boolean {
    return !!(this.currentUser && this.currentUser.permissions === 'Manufacturer');
  }

  get applicationName(): string {
    const hostname = window && window.location
      ? window.location.hostname.toLowerCase()
      : '';
    const turomasDeployment = hostname === 'cut-turomas.vidrioservice.com' ||
      hostname.indexOf('cut-turomas.') === 0;
    return this.isManufacturer || turomasDeployment ? 'VS-Cut oem' : 'VS-Cut';
  }

  get showOefHelp(): boolean {
    return !!this.currentUser;
  }

  private sendClientContext(payloadIn: any): void {
    const timezone = Intl && Intl.DateTimeFormat
      ? Intl.DateTimeFormat().resolvedOptions().timeZone
      : '';
    const payload = Object.assign({}, payloadIn, {
      timezone: timezone || '',
      language: navigator.language || '',
      screen: window.screen ? (window.screen.width + 'x' + window.screen.height) : ''
    });
    this.http.post(this.globals.apiUrl + '/client_context', payload).subscribe(
      () => {},
      error => console.warn('No se pudo registrar el contexto de geolocalización.', error && error.status)
    );
  }

  private captureManufacturerGeolocation(): void {
    if (!this.currentUser || !this.currentUser.user_id) {
      return;
    }
    const sessionKey = 'manufacturer_geolocation_' + this.currentUser.user_id.toString();
    if (sessionStorage.getItem(sessionKey) === 'requested') {
      return;
    }
    sessionStorage.setItem(sessionKey, 'requested');

    if (!(window as any).isSecureContext) {
      this.sendClientContext({ status: 'insecure_context', reason: 'HTTPS requerido por el navegador.' });
      return;
    }
    if (!navigator.geolocation) {
      this.sendClientContext({ status: 'unsupported', reason: 'API de geolocalización no disponible.' });
      return;
    }

    navigator.geolocation.getCurrentPosition(
      position => {
        this.sendClientContext({
          status: 'granted',
          latitude: position.coords.latitude,
          longitude: position.coords.longitude,
          accuracy: position.coords.accuracy,
          altitude: position.coords.altitude,
          captured_at: position.timestamp
        });
      },
      error => {
        const status = error.code === error.PERMISSION_DENIED
          ? 'denied'
          : (error.code === error.TIMEOUT ? 'timeout' : 'unavailable');
        this.sendClientContext({ status: status, reason: error.message || '' });
      },
      { enableHighAccuracy: false, timeout: 10000, maximumAge: 300000 }
    );
  }

  // Función para evitar el error de chequeo por los "ngIf" cambiantes.
  ngAfterViewChecked() {
    // console.log('--> -> ngAfterViewChecked...');
    this.cdRef.detectChanges();
  }

  ngOnInit() {

    this.handleVsBudgetSessionProbe();
    
    // IMPORTANTE: pasar el entorno de la clase como parámetro para
    // que las funciones internas puedan reconocer y modificar las variables.
    let that = this;
    
    // Para el control del diccionario de traducción.
    this.vocabulary$ = this.trans.getVocabulary$();

    this.vocabulary$.subscribe(
      tr => {
            // console.log(' >>>> Diccionario para AppComponent: ');
            // console.log(tr);

            this.tr = tr;

            // Colocamos en el selector de lenguaje el indicado por la clase de traducción.
            this.languageOption = this.trans.actualLanguage;
          }
    );

    this.trans.changeLanguage(this.trans.actualLanguage);

    this.router.routeReuseStrategy.shouldReuseRoute = () => false;

    this.loading = false;
    this.loading1 = false;
    this.loading2 = false;
    this.loading3 = false;
    this.loading4 = false;
    this.loading5 = false;
    this.loading6 = false;

    this.alertModal = false;
    this.alertInfo = '';
    this.infoModal = false;
    this.infoInfo = '';
    this.linkInfo = '';
    this.paramInfo = null;
    this.skinInfo = 'info';

    this.button_color = 'is-primary';
    this.optimizationVisualProgress = 0;
    this.optimizationVisualIteration = 0;
    this.optimizationVisualAttempts = 0;
    this.optimizationVisualStartTs = 0;
    this.optimizationVisualElapsedText = '00:00';
    this.optimizationVisualSpeedLabel = '-';
    this.optimizationVisualSheets = 0;
    this.optimizationCancelRequested = false;
    this.optimizationVisualTimer = null;
    this.optimizationVisualActive = false;
    this.autoExecOverlayVisible = false;
    this.autoExecOverlayCurrentMaterial = '';
    this.autoExecOverlayCompleted = 0;
    this.autoExecOverlayTotal = 0;
    this.autoExecOverlayPending = 0;
    this.autoExecOverlayPercent = 0;
    this.autoExecOverlayCurrentStep = 0;
    this.autoExecOverlayPulse = 0;
    this.autoExecOverlayElapsedText = '00:00';
    this.autoExecOverlayHeartbeatText = '-';
    this.autoExecOverlayStalled = false;
    this.autoExecOverlayTimer = null;

    this.componentActive = true;

    // Tiempo que tardan en cerrarse las ventanas modales de información.
    this.setTimeoutConfirmModal = 2000;

    this.storeRoot.pipe(select(fromRoot.getLoading),
      takeWhile(() => this.componentActive))
      .subscribe(
      loading => {
            // console.log(' >>>> Suscribirse a store loading: ');
            // console.log(loading);

            this.loading = loading;
          }
    );

    this.storeRoot.pipe(select(fromRoot.getLoading1),
      takeWhile(() => this.componentActive))
      .subscribe(
      loading1 => {
            // console.log(' >>>> Suscribirse a store loading1: ');
            // console.log(loading1);

            this.loading1 = loading1;
          }
    );

    this.storeRoot.pipe(select(fromRoot.getLoading2),
      takeWhile(() => this.componentActive))
      .subscribe(
      loading2 => {
            // console.log(' >>>> Suscribirse a store loading2: ');
            // console.log(loading2);

            this.loading2 = loading2;
          }
    );
    this.storeRoot.pipe(select(fromRoot.getLoading3),
      takeWhile(() => this.componentActive))
      .subscribe(
      loading3 => {
            // console.log(' >>>> Suscribirse a store loading3: ');
            // console.log(loading3);

            this.loading3 = loading3;
          }
    );

    this.storeRoot.pipe(select(fromRoot.getLoading4),
      takeWhile(() => this.componentActive))
      .subscribe(
      loading4 => {
            // console.log(' >>>> Suscribirse a store loading4: ');
            // console.log(loading4);

            this.loading4 = loading4;
          }
    );
    this.storeRoot.pipe(select(fromRoot.getLoading5),
      takeWhile(() => this.componentActive))
      .subscribe(
      loading5 => {
            // console.log(' >>>> Suscribirse a store loading5: ');
            // console.log(loading5);

            this.loading5 = loading5;
            this.updateOptimizationVisualState();
          }
    );

    this.storeRoot.pipe(select(fromRoot.getLoading6),
      takeWhile(() => this.componentActive))
      .subscribe(
      loading6 => {
            // console.log(' >>>> Suscribirse a store loading6: ');
            // console.log(loading6);

            this.loading6 = loading6;
            this.updateOptimizationVisualState();
          }
    );

    this.storeRoot.pipe(select(fromRoot.getAlertModal),
      takeWhile(() => this.componentActive))
      .subscribe(
      alertModal => {
            // console.log(' >>>> Suscribirse a store alertModal: ');
            // console.log(alertModal);

            this.alertModal = alertModal;
          }
    );

    this.storeRoot.pipe(select(fromRoot.getAlertInfo),
      takeWhile(() => this.componentActive))
      .subscribe(
      alertInfo => {
            // console.log(' >>>> Suscribirse a store alertInfo: ');
            // console.log(alertInfo);

            this.alertInfo = alertInfo;
          }
    );

    this.storeRoot.pipe(select(fromRoot.getInfoModal),
      takeWhile(() => this.componentActive))
      .subscribe(
      infoModal => {
            // console.log(' >>>> Suscribirse a store infoModal: ');
            // console.log(infoModal);

            this.infoModal = infoModal;

            // Para que la ventana se cierre automáticamente en X segundos.
            if (infoModal) {
              setTimeout(() => { this.confirmInfoModal()}, this.setTimeoutConfirmModal);
            }
          }
    );

    this.storeRoot.pipe(select(fromRoot.getInfoInfo),
      takeWhile(() => this.componentActive))
      .subscribe(
      infoInfo => {
            // console.log(' >>>> Suscribirse a store infoInfo: ');
            // console.log(infoInfo);

            this.infoInfo = infoInfo;
          }
    );

    this.storeRoot.pipe(select(fromRoot.getLinkInfo),
      takeWhile(() => this.componentActive))
      .subscribe(
      linkInfo => {
            // console.log(' >>>> Suscribirse a store linkInfo: ');
            // console.log(linkInfo);

            this.linkInfo = linkInfo;
          }
    );

    this.storeRoot.pipe(select(fromRoot.getParamInfo),
      takeWhile(() => this.componentActive))
      .subscribe(
      paramInfo => {
            // console.log(' >>>> Suscribirse a store paramInfo: ');
            // console.log(paramInfo);

            this.paramInfo = paramInfo;
          }
    );

    this.storeRoot.pipe(select(fromRoot.getSkinInfo),
      takeWhile(() => this.componentActive))
      .subscribe(
      skinInfo => {
            // console.log(' >>>> Suscribirse a store skinInfo: ');
            // console.log(skinInfo);

            this.skinInfo = skinInfo;
            switch (skinInfo) {
              case 'info':
                this.button_color = 'is-primary';
                break;

              case 'alert':
                this.button_color = 'is-danger';
                break;

              default:
                this.button_color = 'is-primary';
                break;
            }
          }
    );

    this.startAutoExecOverlayLoop();
  }

  private handleVsBudgetSessionProbe(): void {
    let isProbeRequest = false;
    try {
      const searchParams = new URLSearchParams(window && window.location ? window.location.search : '');
      isProbeRequest = searchParams.get('vs_budget_probe') === '1';
    } catch (error) {
      isProbeRequest = false;
    }

    if (!isProbeRequest) {
      return;
    }

    const currentUser = this.authenticationService.currentUserValue;
    const hasSession = !!(currentUser && currentUser.user_id !== undefined && currentUser.user_id !== null && currentUser.token);
    const env = localStorage.getItem('enviroment') ? localStorage.getItem('enviroment').toString() : '';

    try {
      if (window && window.opener && !window.opener.closed) {
        window.opener.postMessage({
          channel: 'vs_cut_session_probe',
          has_session: hasSession,
          env: env
        }, '*');
      }
    } catch (error) {}

    setTimeout(() => {
      try {
        window.close();
      } catch (error) {}
    }, 60);
  }

  ngOnDestroy() {
    console.log('--> --> Destruyendo componente APP...');
    // NOTA: De este modo desactivamos todas las subscripciones del componente principal.
    this.componentActive = false;
    this.stopOptimizationVisualLoop();
    this.stopAutoExecOverlayLoop();
  }

  startAutoExecOverlayLoop() {
    this.refreshAutoExecOverlayState();
    if (this.autoExecOverlayTimer) {
      return;
    }
    this.autoExecOverlayTimer = setInterval(() => {
      this.autoExecOverlayPulse = (this.autoExecOverlayPulse + 1) % 4;
      this.refreshAutoExecOverlayState();
    }, 500);
  }

  stopAutoExecOverlayLoop() {
    if (this.autoExecOverlayTimer) {
      clearInterval(this.autoExecOverlayTimer);
      this.autoExecOverlayTimer = null;
    }
    this.autoExecOverlayVisible = false;
  }

  refreshAutoExecOverlayState() {
    const continueFlag = localStorage.getItem('vs_auto_batch_continue') === '1';
    const queue = this.safeParseJsonArray(localStorage.getItem('vs_auto_batch_queue'));
    const total = queue.length;

    if (!continueFlag || total < 1) {
      this.autoExecOverlayVisible = false;
      this.autoExecOverlayCurrentMaterial = '';
      this.autoExecOverlayCompleted = 0;
      this.autoExecOverlayTotal = 0;
      this.autoExecOverlayPending = 0;
      this.autoExecOverlayPercent = 0;
      this.autoExecOverlayCurrentStep = 0;
      this.autoExecOverlayElapsedText = '00:00';
      this.autoExecOverlayHeartbeatText = '-';
      this.autoExecOverlayStalled = false;
      return;
    }

    const indexRaw = localStorage.getItem('vs_auto_batch_index');
    let completed = indexRaw ? Number(indexRaw) : 0;
    if (isNaN(completed) || completed < 0) {
      completed = 0;
    }
    if (completed > total) {
      completed = total;
    }

    const currentJob = this.safeParseJsonObject(localStorage.getItem('vs_auto_batch_current_job'));
    const expectedJob = completed < total ? queue[completed] : null;
    const job = currentJob ? currentJob : expectedJob;

    this.autoExecOverlayVisible = true;
    this.autoExecOverlayCompleted = completed;
    this.autoExecOverlayTotal = total;
    this.autoExecOverlayPending = Math.max(total - completed, 0);
    this.autoExecOverlayPercent = total > 0 ? Math.min(Math.round((completed * 100) / total), 100) : 0;
    this.autoExecOverlayCurrentStep = completed < total ? (completed + 1) : total;
    this.autoExecOverlayCurrentMaterial = this.formatAutoExecMaterialLabel(job);

    const jobStartRaw = localStorage.getItem('vs_auto_batch_job_started_at');
    const jobStartTs = jobStartRaw ? Number(jobStartRaw) : 0;
    const elapsedSec = jobStartTs > 0 ? Math.max(0, Math.floor((Date.now() - jobStartTs) / 1000)) : 0;
    this.autoExecOverlayElapsedText = this.formatAutoExecTime(elapsedSec);

    let localAgeSec = -1;
    const localHbRaw = localStorage.getItem('vs_auto_batch_local_hb');
    if (localHbRaw) {
      try {
        const localHb = JSON.parse(localHbRaw);
        if (localHb && localHb.ts) {
          localAgeSec = Math.max(0, Math.floor((Date.now() - Number(localHb.ts)) / 1000));
        }
      } catch (e) {}
    }
    let backendAgeSec = -1;
    const backendHbRaw = localStorage.getItem('vs_auto_batch_backend_hb');
    if (backendHbRaw) {
      try {
        const backendHb = JSON.parse(backendHbRaw);
        if (backendHb && backendHb.ts) {
          backendAgeSec = Math.max(0, Math.floor((Date.now() - Number(backendHb.ts)) / 1000));
        }
      } catch (e) {}
    }
    const candidateAges = [localAgeSec, backendAgeSec].filter(item => Number.isFinite(item) && item >= 0);
    const freshestAge = candidateAges.length > 0 ? Math.min(...candidateAges) : -1;
    this.autoExecOverlayHeartbeatText = this.formatAutoExecAge(freshestAge);
    this.autoExecOverlayStalled = Math.max(localAgeSec, backendAgeSec) >= 20;
  }

  formatAutoExecTime(totalSecondsIn: number): string {
    const secs = Number.isFinite(totalSecondsIn) && totalSecondsIn > 0 ? Math.floor(totalSecondsIn) : 0;
    const mm = Math.floor(secs / 60);
    const ss = secs % 60;
    return (mm < 10 ? ('0' + mm.toString()) : mm.toString()) + ':' + (ss < 10 ? ('0' + ss.toString()) : ss.toString());
  }

  formatAutoExecAge(secondsIn: number): string {
    if (!Number.isFinite(secondsIn) || secondsIn < 0) {
      return '-';
    }
    if (secondsIn < 60) {
      return secondsIn.toString() + 's';
    }
    const mm = Math.floor(secondsIn / 60);
    const ss = secondsIn % 60;
    return mm.toString() + 'm ' + (ss < 10 ? ('0' + ss.toString()) : ss.toString()) + 's';
  }

  getAutoExecPulseDots(): string {
    return '.'.repeat((this.autoExecOverlayPulse % 4) + 1);
  }

  safeParseJsonArray(rawIn: any): any[] {
    if (!rawIn) {
      return [];
    }
    try {
      const parsed = JSON.parse(rawIn);
      return Array.isArray(parsed) ? parsed : [];
    } catch (e) {
      return [];
    }
  }

  safeParseJsonObject(rawIn: any): any {
    if (!rawIn) {
      return null;
    }
    try {
      const parsed = JSON.parse(rawIn);
      return parsed && typeof parsed === 'object' ? parsed : null;
    } catch (e) {
      return null;
    }
  }

  formatAutoExecMaterialLabel(jobIn: any): string {
    if (!jobIn) {
      return 'Preparando material...';
    }
    const materialId = jobIn.materialid !== undefined && jobIn.materialid !== null ? jobIn.materialid.toString() : '';
    const materialDesc = jobIn.materialdesc ? jobIn.materialdesc.toString() : '';
    if (materialId && materialDesc) {
      return materialId + ' - ' + materialDesc;
    }
    if (materialId) {
      return materialId;
    }
    if (materialDesc) {
      return materialDesc;
    }
    return 'Preparando material...';
  }

  updateOptimizationVisualState() {
    const shouldRun = this.loading5 || this.loading6;
    if (shouldRun && !this.optimizationVisualActive) {
      this.startOptimizationVisualLoop();
      return;
    }

    if (!shouldRun && this.optimizationVisualActive) {
      this.stopOptimizationVisualLoop();
    }
  }

  startOptimizationVisualLoop() {
    this.optimizationVisualActive = true;
    this.optimizationVisualProgress = 0;
    this.optimizationVisualIteration = 1;
    this.optimizationVisualAttempts = 0;
    this.optimizationVisualStartTs = Date.now();
    this.optimizationVisualElapsedText = '00:00';
    this.optimizationVisualSpeedLabel = this.getOptimizationSpeedLabel();
    this.optimizationVisualSheets = 0;
    this.optimizationCancelRequested = false;
    localStorage.setItem('vs_cut_cancel_optimization', '0');
    localStorage.setItem('vs_cut_progress_sheets', '0');

    if (this.optimizationVisualTimer) {
      clearInterval(this.optimizationVisualTimer);
      this.optimizationVisualTimer = null;
    }

    this.optimizationVisualTimer = setInterval(() => {
      this.optimizationVisualProgress += 4;
      if (this.optimizationVisualProgress > 100) {
        this.optimizationVisualProgress = 0;
        this.optimizationVisualIteration += 1;
      }

      // Contador visual dinámico de probaturas.
      this.optimizationVisualAttempts += (2 + Math.floor(Math.random() * 7));

      const elapsedSec = Math.floor((Date.now() - this.optimizationVisualStartTs) / 1000);
      this.optimizationVisualElapsedText = this.formatElapsed(elapsedSec);
      this.optimizationVisualSpeedLabel = this.getOptimizationSpeedLabel();

      const sheetsRaw = localStorage.getItem('vs_cut_progress_sheets');
      const sheetsVal = sheetsRaw ? Number(sheetsRaw) : 0;
      this.optimizationVisualSheets = isNaN(sheetsVal) ? 0 : sheetsVal;
    }, 110);
  }

  stopOptimizationVisualLoop() {
    this.optimizationVisualActive = false;
    if (this.optimizationVisualTimer) {
      clearInterval(this.optimizationVisualTimer);
      this.optimizationVisualTimer = null;
    }
    this.optimizationVisualProgress = 0;
    this.optimizationVisualIteration = 0;
    this.optimizationVisualAttempts = 0;
    this.optimizationVisualStartTs = 0;
    this.optimizationVisualElapsedText = '00:00';
    this.optimizationVisualSpeedLabel = '-';
    this.optimizationVisualSheets = 0;
    this.optimizationCancelRequested = false;
    localStorage.setItem('vs_cut_cancel_optimization', '0');
    localStorage.setItem('vs_cut_progress_sheets', '0');
  }

  formatElapsed(totalSecondsIn: number): string {
    const totalSeconds = totalSecondsIn > 0 ? totalSecondsIn : 0;
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    const mm = minutes < 10 ? ('0' + minutes) : minutes.toString();
    const ss = seconds < 10 ? ('0' + seconds) : seconds.toString();
    return mm + ':' + ss;
  }

  requestCancelOptimization() {
    this.optimizationCancelRequested = true;
    localStorage.setItem('vs_cut_cancel_optimization', '1');
  }

  getOptimizationSpeedLabel(): string {
    const speedRaw = localStorage.getItem('vs_cut_progress_speed');
    if (speedRaw === 'optimal') {
      return 'Óptima';
    }
    if (speedRaw === 'medium') {
      return 'Media';
    }
    if (speedRaw === 'fast') {
      return 'Rápida';
    }
    return '-';
  }

  // IMPORTANTE: Función que se dispara cuando se pulsa el botón de deslogueo del usuario.
  // Debe vaciar todas las variables REDUX que estén vinculadas al usuario que sale.
  logoutButtonClick() {
    this.authenticationService.logout();

    this.store.dispatch(new userActions.ClearUser());
    this.store.dispatch(new fileActions.InicializeFile());
    this.store.dispatch(new optiActions.InicializeOpti());
    this.store.dispatch(new cuttingTableActions.InicializeCuttingTable());
    this.store.dispatch(new easelActions.InicializeEasel());
    this.store.dispatch(new reasonActions.InicializeReason());
  }

  languageButtonClick() {

    console.log('-> Pulsado botón Cambiar Idioma');
    console.log(this.languageOption);

    this.trans.changeLanguage(this.languageOption);

    // Refrescar la misma página en la que estamos.
    //window.location.reload();

    // Ir a la página de inicio donde ya aparecerá todo en el idioma seleccionado.
    this.router.navigate(['./']);

  } // End function languageButtonClick
  
  // Test de Velocidad para el Optimizador
  // Basado en benchmarks de referencia (M3 Pro, A18 Pro, i3, M1)
  testSpeedButtonClick() {
    // console.log('--> Ejecutando función testSpeedButtonClick.');
    
    // Simulación de carga: Cálculo intensivo de 10 millones de iteraciones
    // Este bloque mide la velocidad bruta de ejecución de JavaScript
    let test_iteration = 3;
    let list_result = [];
    
    let control = 0;
    
    const inicio = performance.now();
    
    for (let i = 0; i < test_iteration; i++) {
		
		const inicio_aux = performance.now();
		
	    for (let j = 0; j < 10_000_000; j++) {
	        control += Math.sqrt(j) * Math.sin(j);
	    }
	    
	    const fin_aux = performance.now();
	    const duracionMs_aux = fin_aux - inicio_aux;
	    
	    list_result.push(duracionMs_aux);
	
	} // End For 3.
	
	console.log('-> list result: ');
	console.log(list_result);
	
	let total_time = 0;
	
	list_result.forEach(du => {
		total_time += du;
	});
	
	const fin = performance.now();
	
	const total_duracionMs = fin - inicio;
	
	const duracionMs = total_time / test_iteration;
	
	console.log('-> duracionMs duración media: ');
	console.log(duracionMs);
	
	console.log('-> total_duracionMs duración total: ');
	console.log(total_duracionMs);
	
    // Lógica de categorización basada en tus pruebas
    let diagnostico = '';
    let color = '';
	/*
    if (duracionMs < 40) {
        diagnostico = '<p class="has-background-success">Excelente:</p> Rendimiento nivel M3 Pro / A18 Pro.';
        color = "#28a745"; // Verde
    } else if (duracionMs < 80) {
        diagnostico = '<p class="has-background-info">Bueno:</p> Rendimiento nivel iMac / Escritorio.';
        color = "#ffc107"; // Amarillo/Dorado
    } else if (duracionMs < 150) {
        diagnostico = '<strong><p class="has-background-warning has-text-centered">Moderado</p></strong> <p class="has-text-centered">Posible limitación de batería o hardware antiguo.</p>';
        color = "#fd7e14"; // Naranja
    } else {
        diagnostico = '<p class="has-background-danger">Bajo:</p> El sistema operativo o el hardware están limitando la ejecución.';
        color = "#dc3545"; // Rojo
    } // */
    
    // -------------
    // NUEVA LÓGICA DE CATEGORIZACIÓN (Recalibrada)

	if (duracionMs < 100) {
	    // Tu M3 Pro con 87ms ahora entraría aquí holgadamente
	    diagnostico = '<strong><p class="has-background-success has-text-centered">Excelente:</p></strong><p class="has-text-centered">Tu hardware está optimizado para el máximo rendimiento.</p>';
	    color = "#28a745"; // Verde
	} else if (duracionMs < 180) {
	    diagnostico = '<strong><p class="has-background-info has-text-centered">Bueno:</p></strong><p class="has-text-centered">Rendimiento sólido para el optimizador.</p>';
	    color = "#82c91e"; // Verde lima
	} else if (duracionMs < 300) {
	    diagnostico = '<strong><p class="has-background-warning has-text-centered">Moderado</p></strong><p class="has-text-centered">El rendimiento es estable, pero podría ser más rápido.</p>';
	    color = "#ffc107"; // Amarillo
	} else {
	    diagnostico = '<strong><p class="has-background-danger has-text-centered">Bajo:</p></strong> <p class="has-text-centered">Se recomienda revisar el ahorro de energía o procesos en segundo plano.</p>';
	    color = "#dc3545"; // Rojo
	}
    
    
    // -------------

    console.log(`Test finalizado en: ${total_duracionMs.toFixed(2)}ms. Control: ${control}`);
    console.log(`RESULTADO DEL TEST:\n\nVelocidad de procesado: ${duracionMs.toFixed(0)} unidades.\nDiagnóstico: ${diagnostico}`);
    
    let result1 = `Test finalizado en: ${total_duracionMs.toFixed(2)}ms.`;
    let result2 = `Control: ${control}`;
    let result3 = `Velocidad de procesado = ${duracionMs.toFixed(0)} unidades.`;
    let result4 = `Diagnóstico:${diagnostico}`;
    
    this.alertInfo = '<strong>RESULTADO DEL TEST DE VELOCIDAD</strong><br>' + result1 + '<br>' + result2  + '<br>' + result3 + '<br>' + result4;
		
	this.showInfoModal(true, this.alertInfo, '', null, 'info');
	
  } // End function testSpeedButtonClick

  // -------------------------------
  //  Ventanas modales informativas
  // -------------------------------

  showInfoModal(value: boolean, info: string, link: string, param: any, skin: string) {

    console.log('---->>>>.... Ejecutando APP showInfoModal: ' + value + ' ;Info: ' + info + ' ;Param: ' + param + ' ;Link: ' + link);

    this.storeRoot.dispatch( new rootActions.ChangeInfoModal({value: value, info: info, link: link, param: param, skin: skin}));

  } // End function showInfoModal

  confirmInfoModal() {
    console.log('---->>>>.... Ejecutando APP confirmInfoModal. Link = ' + this.linkInfo + ' ;Param = ' + this.paramInfo);

    this.navigateInfoModal();

    this.hideInfoModal();

  } // End function confirmInfoModal

  navigateInfoModal() {
    if (this.linkInfo !== '' && this.linkInfo !== null && this.linkInfo !== undefined) {
      if (this.paramInfo !== undefined && this.paramInfo !== null && this.paramInfo !== '') {
        console.log('---> Encontrado parámetro de enrutamiento: ');
        console.log(this.paramInfo);

        this.router.navigate([this.linkInfo, this.paramInfo]);
      } else {
        this.router.navigate([this.linkInfo]);
      }
    }
  } // End function navigateInfoModal

  hideInfoModal() {

    console.log('---->>>>.... Ejecutando APP hideInfoModal.');

    this.storeRoot.dispatch( new rootActions.ChangeInfoModal({value: false, info: '', link: '', param: null, skin: 'info'}));

  } // End function hideInfoModal


  showAlertModal(value: boolean, info: string) {

    console.log('---->>>>.... Ejecutando APP showAlertModal: ' + value + ' ;Info: ' + info);
    
    this.storeRoot.dispatch( new rootActions.ChangeAlertModal({value: true, info: info}));
    this.alertModal = value;
    this.alertInfo = info;

  } // End function showAlertModal

  confirmAlertModal() {
    console.log('---->>>>.... Ejecutando APP confirmAlertModal.');

    this.storeRoot.dispatch( new rootActions.ChangeAlertModal({value: false, info: ''}));
    // this.showAlertModal(false);

  } // End function confirmAlertModal

}
